"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const borderWidths = {
  "lg": "4px",
  "md": "2px",
  "sm": "1px"
};
exports.default = borderWidths;